import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translation_uz from './locales/uz/translation.json';
import translation_ru from './locales/ru/translation.json';

const resources = {
    uz: {
        translation: translation_uz
    },
    ru: {
        translation: translation_ru
    }
};

i18n
    // brauzer tilini avtomatik aniqlash
    .use(LanguageDetector)
    // react-i18next ga o'tkazish
    .use(initReactI18next)
    // i18next ni sozlash
    .init({
        resources,
        // Agar foydalanuvchi brauzerida til aniqlanmasa, sukut bo'yicha 'uz' ishlatiladi.
        fallbackLng: 'uz',

        // Foydalanuvchi xabarlari uchun kalit:value
        ns: ['translation'],
        defaultNS: 'translation',

        interpolation: {
            escapeValue: false, // React allaqachon XSS himoyasiga ega
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        }
    });

export default i18n;